import { useEffect, useRef, useState } from 'react';
import { usePresentation } from '../presentation/PresentationContext';
import { artAsset } from './assets';

/** Decorative public artwork. Labels and controls always remain outside the image. */
export function ArtImage({ source, className = '' }: { source?: string; className?: string }) {
  const { presentation } = usePresentation();
  const ref = useRef<HTMLSpanElement>(null);
  const [width, setWidth] = useState(400);
  const [failed, setFailed] = useState<string | null>(null);
  useEffect(() => {
    const el = ref.current;
    if (!el || typeof ResizeObserver === 'undefined') return;
    const measure = () => setWidth(Math.max(1, Math.ceil(el.getBoundingClientRect().width)));
    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(el);
    return () => observer.disconnect();
  }, []);
  const id = source?.startsWith('asset:') ? source.slice(6) : null;
  const image = presentation && id ? artAsset(presentation, id, width) : null;
  return <span ref={ref} className={`scene-art ${className}`} aria-hidden="true">
    {image && image.url !== failed && <img src={image.url} alt="" loading="lazy" decoding="async" onError={() => setFailed(image.url)} />}
  </span>;
}
